import getDatasourceByType from './utils/getDatasourceByType';

export default function() {
    return new Promise((resolve, reject) => {
        getDatasourceByType({
            type: 'GroupAssistant'
        })
            .then(list => {
                resolve(list);
            })
            .catch(err => {
                reject(err);
            });
    });
}
